import style from './Divider.module.scss'

export const Divider = () => <hr className={style.hr} />
